import { useEffect, useMemo, useRef, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Modal } from "react-bootstrap";
import * as actions from "../../../../../_redux/student-pre-interviews/StudentPreInterviewsAction";
import { redirectToPages, resultAlert } from "../../../../../../../../_helpers/Helpers";
import { ModalProgressBar } from "../../../../../../../../_metronic/_partials/controls";
import { useInterviewsUIContext } from "../InterviewsUIContext";
import { InterviewEditForm } from "./InterviewEditForm";

export function InterviewEdit({
  id,
  showInterviewEdit,
  closeInterviewEdit
}) {
  // Interviews UI Context
  const interviewsUIContext = useInterviewsUIContext();
  const interviewsUIProps = useMemo(() => {
    return {
      queryParams: interviewsUIContext.queryParams,
    };
  }, [interviewsUIContext]);

  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, interview } = useSelector(
    (state) => ({
      actionsLoading: state.studentPreInterviews.actionsLoading,
      isSuccess: state.studentPreInterviews.isSuccess,
      type: state.studentPreInterviews.type,
      interview: state.studentPreInterviews.interview
    }),
    shallowEqual
  );
    
  useEffect(() => {
    if (id) dispatch(actions.getInterview(id));
    return () => dispatch(actions.cleanInterviewState());
  }, [id, dispatch]);

  useEffect(() => {
    let _title = "Görüşme";
    let action = id ? "Düzenle" : "Ekle";
    _title += " " + action;
    setTitle(_title);
  }, [id]);

  /** Belli Bir Görüşmeyi Kaydeder */
  const saveInterview = (values) => {
    if (!id) values.preInterviewId = interviewsUIProps.queryParams.filter.preInterviewId;
    dispatch(actions.saveInterview(values)).then((result) => onResult(result));
  };
    
  const onResult = ({ isSuccess, type, message }) => {
    resultAlert(type, message);
    if (isSuccess) setTimeout(() => {
      closeInterviewEdit();
      dispatch(actions.cleanListState());
      dispatch(actions.getInterviews(interviewsUIProps.queryParams));
    }, 2500);
  };

  const btnRef = useRef();  
  const saveInterviewClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  return (
    <Modal
      show={showInterviewEdit}
      onHide={closeInterviewEdit}
      aria-labelledby="timetable-transfer-title"
    >
      {actionsLoading && <ModalProgressBar />}
      <Modal.Header className="justify-content-center" closeButton>
        <Modal.Title id="timetable-transfer-title">{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="mt-5">
          <InterviewEditForm
            btnRef={btnRef}
            interview={interview}
            saveInterview={saveInterview}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="justify-content-center">
        <button
          type="submit"
          className="btn btn-primary"
          onClick={saveInterviewClick}
        >
          Kaydet
        </button>
        <button
          type="button"
          className="btn btn-danger"
          onClick={closeInterviewEdit}
        >
          Vazgeç
        </button>
      </Modal.Footer>
    </Modal>
  );
}